"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pellegrino-parmense": {
    "5101a927": [{
      "hkey": "99b7c91f",
      "slug": "aione",
      "name": "Aione",
      "primary": true,
      "skipSearch": false
    }],
    "aione-di-sopra": [{
      "hkey": "99b7c91f",
      "slug": "aione",
      "name": "Aione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "34b07ebd": [{
      "hkey": "9ffdedc0",
      "slug": "pietraspaccata",
      "name": "Pietraspaccata",
      "primary": true,
      "skipSearch": false
    }],
    "pietra-spaccata": [{
      "hkey": "9ffdedc0",
      "slug": "pietraspaccata",
      "name": "Pietraspaccata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;